import { Column } from 'shared/types/models/EditMetrics';

export function getFactColumnsIDs(columns: Column[]) {
  return columns
    .filter(x => x.kind === 'ratio' || (x.kind === 'metric' && x.metricType !== 'plan'))
    .map(x => x.id);
}
